import * as React from "react";

const GoogleLogo = (props) => (
  <svg
    className="svg"
    width={18}
    height={18}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.146 4.146 0 0 1-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
      fillRule="evenodd"
      fill="#4285f4"
    />
    <path
      d="M9.003 18c2.43 0 4.467-.806 5.956-2.18l-2.909-2.26c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332A8.996 8.996 0 0 0 9.003 18z"
      fillRule="evenodd"
      fill="#34a853"
    />
    <path
      d="M3.964 10.712a5.41 5.41 0 0 1-.282-1.71c0-.593.102-1.17.282-1.71V4.96H.957a9.005 9.005 0 0 0 0 8.084l3.007-2.332z"
      fillRule="evenodd"
      fill="#fbbc05"
    />
    <path
      d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.002 0A8.996 8.996 0 0 0 .96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71z"
      fillRule="evenodd"
      fill="#ea4335"
    />
  </svg>
);

export default GoogleLogo;
